export const initialValues = {
    selectedMedications: [],
    lastVisitToDoctor: null,
    additionalDiseases: null,
    importantInformation: '',
    uploadedFile: null,
    agreement: false,
    personalInformation: {
        name: '',
        surname: '',
        email: '',
        phone: '',
        address: '',
        houseNumber: '',
        city: '',
        zipCode: '',
        pesel: '',
    },
};
